import styled from "styled-components";

export const Container = styled.div`
  display: none;
  z-index: 10;
  position: absolute;
  height: 15vh;
  width: 70vw;
  max-width: 900px;
  max-height: 500px;
  margin-left: 20vw;
  margin-top: 35vh;
  padding: 1% 2%;
  background-color: #fff;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 45px;
  transform: rotate(90deg);
  @media only screen and (min-width: 867px) {
    transform: rotate(0deg);
    width: 30vw;
    height: 30vh;
    margin-left: 35%;
    margin-top: 10%;
  }
`;
